<template>
  <div>
    <h3 class="d-flex justify-start py-5">{{ $t('share_links.title_plural') }}</h3>
    <v-data-table
      :loading="loading"
      :items="shareLinksList"
      :headers="headers"
      :no-data-text="$t('table_settings.no_data')"
      :loading-text="$t('table_settings.loading_data')"
      :header-props="{
        sortByText: $t('table_settings.sort_by')
      }"
      :footer-props="{
        itemsPerPageAllText: $t('table_settings.all'),
        itemsPerPageOptions: [10, 25, 50, -1],
        itemsPerPageText: $t('table_settings.items_per_page')
        }">
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="editItem(item)">
          mdi-pencil-outline
        </v-icon>
        <v-icon
          small
          color="red"
          class="mr-1"
          @click="deleteItem(item)">
          mdi-delete-outline
        </v-icon>
        <v-icon
          color="blue"
          small
          class="mr-1"
          @click="copyLink(item)">
          mdi-share-outline
        </v-icon>
      </template>
      <template v-slot:[`item.creationDate`]="{ item }">
        {{ formatDate(item.creationDate) }}
      </template>
      <template v-slot:[`item.expireDate`]="{ item }">
        {{ formatDate(item.expireDate) }}
      </template>
    </v-data-table>
    <share-link-editor
        :initLink="editedItem"
        :initCollections="availableCollections"
        :show-dialog="this.showDialog"
        @onAdd="onAdd"
        @onEdit="onEdit"
        @onCancel="onSaveCancel" />
    <div class="mx-10">
      <v-col class="text-right">
        <v-btn fab small color="primary" @click="addItem" absolute>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </div>
    <v-snackbar v-model="showLinkCopiedSnackbar" color="info">
      {{ $t('share_links.copy_link_success') }}
    </v-snackbar>
    <v-snackbar v-model="showDeleteErrorSnackbar" color="error">
      {{ $t('common_error.could_not_delete_item') }}
    </v-snackbar>
    <v-snackbar v-model="showLoadingErrorSnackbar" color="error">
      {{ $t('common_error.could_not_load_items')}}
    </v-snackbar>
    <confirm-dialog :show-dialog="this.showConfirmDeleteDialog"
      confirm-color="error"
      :question-text="this.confirmDeleteDialogText"
      :positive-text="$t('common_actions.delete')"
      :negative-text="$t('common_actions.cancel')"
      @onCancel="cancelDeleteItem"
      @onConfirm="confirmDeleteItem">
    </confirm-dialog>
  </div>
</template>

<script>
import ShareLinkService from '@/services/shareLinks/ShareLinkService.js'
import ShareLinkEditor from './ShareLinkEditor.vue'
import i18n from '@/plugins/i18n'
import moment from 'moment'
import ConfirmDialog from '../common/ConfirmDialog.vue'

export default {
  name: 'ShareLinks',
  components: {
    ShareLinkEditor,
    ConfirmDialog
  },
  data () {
    return {
      shareLinksList: [],
      loading: true,
      showDeleteErrorSnackbar: false,
      showLoadingErrorSnackbar: false,
      showConfirmDeleteDialog: false,
      showLinkCopiedSnackbar: false,
      confirmDeleteDialogText: '',
      baseUrl: '',
      editedItem: {
        id: 0,
        name: '',
        code: '',
        creationDate: '',
        expireDate: new Date('2099-12-31'),
        link: '',
        collections: []
      },
      availableCollections: [],
      showDialog: false,
      headers: [
        {
          text: i18n.t('share_links.name'),
          value: 'name',
          align: 'start',
          sortable: true
        },
        {
          text: i18n.t('share_links.created'),
          value: 'creationDate',
          align: 'start',
          sortable: true
        },
        {
          text: i18n.t('share_links.expires'),
          value: 'expireDate',
          align: 'start',
          sortable: true
        },
        {
          text: i18n.t('table_settings.edit'),
          align: 'end',
          value: 'edit',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    this.loading = true
    ShareLinkService.getBaseUrl().then(data => {
      this.baseUrl = data
    })
    ShareLinkService.getAvailableCollections().then(data => {
      this.availableCollections = data
    })
    ShareLinkService.getAllLinks().then(data => {
      this.shareLinksList = data
      this.loading = false
    }, _ => {
      this.loading = false
      this.showLoadingErrorSnackbar = true
    })
  },
  methods: {
    copyLink (item) {
      navigator.clipboard.writeText(this.baseUrl + '#/LinkLogin/' + item.code + '/' + item.link)
      this.showLinkCopiedSnackbar = true
    },
    formatDate (date) {
      return moment(date).format('D.M.yyyy')
    },
    editItem (item) {
      this.editedItem = item
      this.showDialog = true
    },
    deleteItem (item) {
      this.editedItem = item
      this.confirmDeleteDialogText = i18n.t('common_actions.confirm_delete', { name: item.name })
      this.showConfirmDeleteDialog = true
    },
    addItem () {
      this.editedItem = {
        id: 0,
        name: '',
        code: '',
        creationDate: '',
        expireDate: new Date('2099-12-31'),
        link: '',
        collections: []
      }
      this.showDialog = true
    },
    cancelDeleteItem () {
      this.showConfirmDeleteDialog = false
    },
    confirmDeleteItem () {
      this.showConfirmDeleteDialog = false
      this.loading = true
      ShareLinkService.removeLink(this.editedItem).then(result => {
        this.loading = false
        this.shareLinksList.splice(this.shareLinksList.indexOf(this.editedItem), 1)
      }, _ => {
        this.loading = false
        this.showDeleteErrorSnackbar = true
      })
    },
    onAdd () {
      this.showDialog = false
      this.shareLinksList.push(this.editedItem)
    },
    onEdit () {
      this.showDialog = false
    },
    onSaveCancel () {
      this.showDialog = false
      this.editedItem = {
        id: 0,
        name: '',
        code: '',
        creationDate: '',
        expireDate: new Date('2099-12-31'),
        link: '',
        collections: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shareLinks/ShareLinks.vue